import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Brand } from 'src/models/brand';
import { User } from 'src/models/user';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Input() userProfile?: User;
  
  constructor(public helperService: HelperService,
    private translate: TranslateService) {
     
     }

  ngOnInit(): void {
  }

}
